/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class ZendeskWidgetControl extends React.Component {
    constructor(props) {
        super(props);

        this.displayWidget = this.displayWidget.bind(this);

    }

    componentDidMount() {

        this.displayWidget();

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.displayHelp != this.props.displayHelp) {
            this.displayWidget();
        }

    }

    displayWidget() {

        if (this.props.displayHelp) {
            if (typeof zE !== 'undefined') {
    			zE(function() {
    				zE.show();
    			});
    		}
        } else {
            if (typeof zE !== 'undefined') {
    			zE(function() {
    				zE.hide();
    			});
    		}
        }
    }

    render() {
        return null;
    }
}

ZendeskWidgetControl.displayName = "ZendeskWidgetControl";

ZendeskWidgetControl.propTypes = {
    displayHelp: PropTypes.bool
};

ZendeskWidgetControl.defaultProps = {
    displayHelp: true
};

export default ZendeskWidgetControl;
